import React from 'react';

import { TRecommendation } from '@/services/requests/Recommendation/types/template1';

type TProps = {
  data: TRecommendation;
};

export function Subtitle({ data }: TProps) {
  return (
    <h5
      className="vitrine-template1__subtitle"
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{
        __html: data.subtitle || '',
      }}
    />
  );
}
